import { supabase } from '@/lib/supabase';
import type { Subscriber } from '@/types/db';

// Subscribe with graceful duplicate handling (email is UNIQUE in the DB).
export async function subscribe(email: string, language: string): Promise<'ok' | 'exists'> {
  const clean = email.trim().toLowerCase();
  const { error } = await supabase
    .from('newsletter_subscribers')
    .insert({ email: clean, language: language.split('-')[0], status: 'aktiv' });
  if (error) {
    if (error.code === '23505') return 'exists'; // unique_violation
    throw error;
  }
  return 'ok';
}

export async function getSubscribers(status?: string): Promise<Subscriber[]> {
  let query = supabase
    .from('newsletter_subscribers')
    .select('*')
    .order('created_at', { ascending: false });
  if (status && status !== 'all') query = query.eq('status', status);
  const { data, error } = await query;
  if (error) throw error;
  return data ?? [];
}

export async function updateSubscriberStatus(id: number, status: string): Promise<void> {
  const { error } = await supabase.from('newsletter_subscribers').update({ status }).eq('id', id);
  if (error) throw error;
}

export async function deleteSubscriber(id: number): Promise<void> {
  const { error } = await supabase.from('newsletter_subscribers').delete().eq('id', id);
  if (error) throw error;
}
